import { Injectable } from "@angular/core";
import { MapHelperService } from "src/services/map-helper.service";

@Injectable()
export class GeocoderService {
    sourceName: string = 'geocoder-icon-source';
    layerName: string = 'geocoder-icon-layer';
    constructor(private mapHelperService: MapHelperService) {}

    createLayer(suffix: string, layerDisplaySuffix: string){
        this.sourceName = suffix + '-' + this.sourceName;
        this.layerName = suffix + '-' + this.layerName;
        const existingSource = this.mapHelperService.GetSourceByName(this.sourceName);
        if (!existingSource) {
            this.mapHelperService.AddSourceEmptyGeoJson(this.sourceName, "Punto de " + layerDisplaySuffix, 'map.png');
            this.mapHelperService.AddLayerIcon(this.layerName, this.sourceName, 'map.png', "Punto de geocodificación", 0.03, [0, -15]);
        }
    }

    clearLayer(){
        this.mapHelperService.UpdateLayerGeoJson(this.sourceName, this.mapHelperService.Empty_GeoJson);
    }
}